import { showNotification } from 'app/providers/NotificationsProvider';
import { BookingMapUnpickableTapKind } from './getBookingMapUnpickableTapKind';

export type BookingMapUnpickableTapTranslate = (key: string) => string;

export const showBoxNotification = (kind: BookingMapUnpickableTapKind, translate: BookingMapUnpickableTapTranslate): void => {
  const title = translate('Cannot select this box');
  const description =
    kind === BookingMapUnpickableTapKind.INACTIVE
      ? translate('This box currently is unavailable.')
      : translate('To choose this box, please select another size category.');

  showNotification('info', title, description);
};
